import request from '../../utils/request'
import config from '../../../config/config'
// const baseURL = 'http://localhost:3013'
const baseURL = config.baseUrl;

//  订单查询
export function ordersPageList (data) {
  return request({
    url: baseURL + 'order/pageList',
    method: 'post',
    data: data
  })
}
//  发货
export function ordersUpdate (data) {
  return request({
    url: baseURL + 'order/update',
    method: 'post',
    data: data
  })
}




// WEBPACK FOOTER //
// ./src/api/orders/index.js